import { render, staticRenderFns } from "./LoginWithGoogleButton.vue?vue&type=template&id=136e358b&scoped=true&"
import script from "./LoginWithGoogleButton.vue?vue&type=script&lang=js&"
export * from "./LoginWithGoogleButton.vue?vue&type=script&lang=js&"
import style0 from "./LoginWithGoogleButton.vue?vue&type=style&index=0&id=136e358b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136e358b",
  null
  
)

export default component.exports